import { render, staticRenderFns } from "./templateFrom.vue?vue&type=template&id=ca39247a&scoped=true"
import script from "./templateFrom.vue?vue&type=script&lang=js"
export * from "./templateFrom.vue?vue&type=script&lang=js"
import style0 from "./templateFrom.vue?vue&type=style&index=0&id=ca39247a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca39247a",
  null
  
)

export default component.exports